import React, { useEffect, useRef } from 'react';

const QuarryMapView = ({ imageUrl, shelves, onSelectShelf }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (!imageUrl) return;
        const img = new Image();
        img.src = imageUrl;
        img.onload = () => {
            draw(img, shelves);
        };
    }, [imageUrl, shelves]);

    const draw = (img, currentShelves) => {
        const canvas = canvasRef.current;
        if (!canvas || !img) return;
        const ctx = canvas.getContext('2d');
        
        // Clear canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        // Draw image
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        
        // Draw polygons
        currentShelves.forEach(shelf => {
            const currentPoints = shelf.polygon;
            if (currentPoints && currentPoints.length > 0) {
                ctx.beginPath();
                ctx.moveTo(currentPoints[0].x * canvas.width, currentPoints[0].y * canvas.height);
                for (let i = 1; i < currentPoints.length; i++) {
                    ctx.lineTo(currentPoints[i].x * canvas.width, currentPoints[i].y * canvas.height);
                }
                if (currentPoints.length > 2) {
                    ctx.closePath();
                }
                ctx.strokeStyle = 'red';
                ctx.lineWidth = 2;
                ctx.stroke();
                ctx.fillStyle = 'rgba(255, 0, 0, 0.2)';
                ctx.fill();
                
                // Draw label with background for better visibility
                const text = shelf.name;
                ctx.font = 'bold 14px Arial';
                const textMetrics = ctx.measureText(text);
                const textWidth = textMetrics.width;
                const textHeight = 14; // Approximate
                const labelX = currentPoints[0].x * canvas.width;
                const labelY = currentPoints[0].y * canvas.height - 10;

                ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
                ctx.fillRect(labelX - 2, labelY - textHeight, textWidth + 4, textHeight + 4);
                
                ctx.fillStyle = 'black';
                ctx.fillText(text, labelX, labelY);
            }
        });
    };

    const handleCanvasClick = (e) => {
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        const clickX = (e.clientX - rect.left) / canvas.width;
        const clickY = (e.clientY - rect.top) / canvas.height;

        // Simple point-in-polygon could be added here if needed, 
        // but for now we'll just rely on the list or simple hit testing if points are nearby.
        // For simplicity, let's just trigger selection if the click is near the first point of a polygon
        const selectedShelf = shelves.find(shelf => {
            if (!shelf.polygon || shelf.polygon.length === 0) return false;
            const p = shelf.polygon[0];
            const dist = Math.sqrt(Math.pow(p.x - clickX, 2) + Math.pow(p.y - clickY, 2));
            return dist < 0.05; // 5% radius
        });

        if (selectedShelf) {
            onSelectShelf(selectedShelf);
        }
    };

    return (
        <div style={{ position: 'relative', overflow: 'hidden', border: '1px solid #ccc' }}>
            <canvas 
                ref={canvasRef} 
                width={1200} 
                height={600} 
                onClick={handleCanvasClick}
                style={{ cursor: 'pointer', display: 'block' }}
            />
            <small className="text-muted p-2 d-block">Χάρτης Παταριών. Κάντε κλικ σε ένα πατάρι για επεξεργασία.</small>
        </div>
    );
};

export default QuarryMapView;
